<template>
  <div class="addApplicationForVehicle">
    <div class="newsDetial-header">
      <template v-if="!detailsId">
        <div class="newsDetial-title">新建表单</div>
        <blank height="15"> </blank>
        <div class="newsDetial-abstract">
          请按照文本要求添加表单，并提交进行流程审批
        </div>
        <blank height="45"> </blank>
      </template>
      <template v-else>
        <a-tabs>
          <a-tab-pane key="1" tab="报销详情" />
        </a-tabs>
      </template>
    </div>
    <!-- 页面内容 -->
    <div class="detial-cont">
      <div class="detial-cont-title">基本信息</div>
      <blank height="1"> </blank>
      <!-- 基本信息 -->
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <!-- 第一行 姓名 -->
          <a-descriptions-item>
            <!-- 报销职工姓名 -->
            <span slot="label">姓名<span class="required">*</span> </span>
            <a-input
              disabled
              allowClear
              class="w300"
              placeholder=""
              v-model="baseInfo.fullName"
            />
          </a-descriptions-item>
          <!-- 身份证号码 -->
          <a-descriptions-item>
            <span slot="label">身份证号码<span class="required">*</span></span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.idCardNumber"
            />
          </a-descriptions-item>
          <!-- 报销年度 -->
          <a-descriptions-item>
            <span slot="label"> 报销年度 </span>
            <a-select
              allowClear
              placeholder=""
              class="w300"
              v-model="baseInfo.year"
              disabled
            >
              <a-select-option
                v-for="(item, index) in yearList"
                :key="index"
                :value="item"
                >{{ item + '年度' }}</a-select-option
              >
            </a-select>
          </a-descriptions-item>

          <!-- 第二行  门诊自付一金额（元）-->
          <a-descriptions-item>
            <span slot="label">门诊自付一金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.outpatientSelfPaymentOne"
            />
          </a-descriptions-item>
          <!-- 门诊自付二金额（元） -->
          <a-descriptions-item>
            <span slot="label">门诊自付二金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.outpatientSelfPaymentTwo"
            />
          </a-descriptions-item>
          <!-- 门诊自费金额（元） -->
          <a-descriptions-item>
            <span slot="label">门诊自费金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.outpatientSelfExpense"
            />
          </a-descriptions-item>

          <!-- 第三行 住院自付一金额-->
          <a-descriptions-item>
            <span slot="label">住院自付一金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.hospitalizationSelfPaymentOne"
            />
          </a-descriptions-item>
          <!-- 住院自付二金额（元） -->
          <a-descriptions-item>
            <span slot="label">住院自付二金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.hospitalizationSelfPaymentTwo"
            />
          </a-descriptions-item>
          <!-- 住院自费金额（元） -->
          <a-descriptions-item>
            <span slot="label">住院自费金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.hospitalizationSelfExpense"
            />
          </a-descriptions-item>

          <!-- 第四行 自付一总金额（元） -->
          <a-descriptions-item>
            <span slot="label">自付一总金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.totalSelfPaymentOne"
            />
          </a-descriptions-item>
          <!-- 自付二总金额（元） -->
          <a-descriptions-item>
            <span slot="label">自付二总金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.totalSelfPaymentTwo"
            />
          </a-descriptions-item>
          <!-- 自费总金额（元） -->
          <a-descriptions-item>
            <span slot="label">自费总金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.totalSelfExpense"
            />
          </a-descriptions-item>

          <!-- 第五行 最后一个 -->
          <a-descriptions-item>
            <span slot="label">实际报销总金额（元） </span>
            <a-input
              disabled
              class="w300"
              placeholder=""
              v-model="baseInfo.totalFee"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>

      <!-- 底部操作按钮 -->
      <bottomSuspension>
        <!-- <p class="bottom-cue">{{ bottomCueMsg }}</p> -->
        <a-button :style="{ marginRight: '20px' }" @click="goBack">
          返回
        </a-button>
      </bottomSuspension>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getYear, getReimbursementDetails, getUserList } from './api/api'
export default {
  components: {},

  data() {
    return {
      detailsId: null, // 查看id
      yearList: [], // 年度下拉
      baseInfo: {} // 基本信息
    }
  },
  computed: {
    ...mapState(['app']),
    disabled() {
      if (this.detailsId) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {},
  created() {
    this.getYearFn()
    if (this.$route.query.id) {
      this.detailsId = this.$route.query.id
      // 查询详情  回显
      this.getReimbursementDetailsFn()
    }
  },
  methods: {
    // 获取报销详情
    getReimbursementDetailsFn() {
      getReimbursementDetails(this.detailsId).then((res) => {
        if (res.data.code == 0) {
          console.log('报销详情', res.data)
          this.baseInfo = res.data.data
        }
      })
    },
    // 返回
    goBack() {
      this.$router.go(-1)
    },

    // 年度下拉
    getYearFn() {
      getYear().then((res) => {
        if (res.data.code == 0) {
          this.yearList = res.data.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addApplicationForVehicle {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.bottom-cue {
  line-height: 56px;
  margin: 0;
  margin-right: 30px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/MedicalFee/yearDetail.vue